module.exports = __webpack_public_path__ + "r-v3/img/chat.3b3b2dfc.svg";